export const num2name = {
    0: "QUERY_PARAM_DATA_TYPE_UNSPECIFIED",
    1: "USER_AUTH_ID",
};
export const name2num = {
    QUERY_PARAM_DATA_TYPE_UNSPECIFIED: 0,
    USER_AUTH_ID: 1,
};
